import { render, staticRenderFns } from "./ydIndex.vue?vue&type=template&id=3a7fea04&scoped=true&"
import script from "./ydIndex.vue?vue&type=script&lang=js&"
export * from "./ydIndex.vue?vue&type=script&lang=js&"
import style0 from "./ydIndex.vue?vue&type=style&index=0&id=3a7fea04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7fea04",
  null
  
)

export default component.exports